import { render, staticRenderFns } from "./PainterPublish.vue?vue&type=template&id=4d708ab8&scoped=true"
import script from "./PainterPublish.vue?vue&type=script&lang=js"
export * from "./PainterPublish.vue?vue&type=script&lang=js"
import style0 from "./PainterPublish.vue?vue&type=style&index=0&id=4d708ab8&prod&lang=scss&scoped=true"
import style1 from "./PainterPublish.vue?vue&type=style&index=1&id=4d708ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d708ab8",
  null
  
)

export default component.exports